<template>
  <div>
    <b-row v-if="loading">
      <b-col cols="12">
        <loading-card />
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="12">
        <default-card
          title="Genel Toplam"
          :value="allocations.grandTotals.count"
          icon="InfoIcon"
          color="success"
        />
      </b-col>
      <b-col
        cols="12"
        md="7"
      >
        <b-row>
          <b-col
            v-for="item in allocations.data"
            :key="item.id"
            cols="12"
            md="6"
          >
            <default-card
              :title="item.title"
              :value="item.count"
              icon="InfoIcon"
              color="info"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col
        cols="12"
        md="5"
      >
        <pie-charts
          :series-data="allocations.grandTotals.chartData.series"
          :categories-data="allocations.grandTotals.chartData.labels"
          chart-title="Tahsis Stoklar"
          chart-type="donut"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BCol, BRow } from 'bootstrap-vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import DefaultCard from '@/layouts/components/ReportCards/DefaultCard.vue'
import PieCharts from '@/layouts/components/ReportCharts/PieCharts.vue'

export default {
  name: 'AllocationStocks',
  components: {
    BRow,
    BCol,
    LoadingCard,
    DefaultCard,
    PieCharts,
  },
  computed: {
    loading() {
      return this.$store.getters['saleStocksReports/loading']
    },
    allocations() {
      return this.$store.getters['saleStocksReports/allocations']
    },
  },
  created() {
    this.getAllocations()
  },
  methods: {
    getAllocations() {
      this.$store.dispatch('saleStocksReports/getAllocations')
    },
  },
}
</script>
